import { Box } from '@mui/material';
import React from 'react';
import { Col, Divider, Row } from "rsuite";
import ServicesTable from './ServicesTable';
import ServiceTableSingleRow from './ServiceTableSingleRow';


type Props = { detailedData: CustomerDetails, selectedCustomerId: any, selectedScatterData: Customer[], selectedDistrict?: string, isFilterExpanded: boolean }

const CustomerSelectedOpportunities = ({ detailedData, selectedCustomerId, selectedScatterData, selectedDistrict, isFilterExpanded }: Props) => {
    return (<Box sx={{ height: '100%' }}>

        <div className='chart-title font-bold pb-[5px] w-full text-center' >
            Opportunities for Customer: {detailedData.customerDesc} (Sold To: {detailedData.customerId})
        </div>
        <Row className="show-grid  m-0" id='opportunities' >
            <Col xs={24} sm={24} md={11} className="h-full" >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: "0.8vh" }}>
                    <ServicesTable isFilterExpanded={isFilterExpanded} selectedScatterData={selectedScatterData} data={detailedData?.pricing} headerValue='pricing' selectedCustomerId={selectedCustomerId} />
                    <ServiceTableSingleRow isFilterExpanded={isFilterExpanded} heading='bci' count={detailedData?.bci?.itemsCount} opportunity={detailedData?.bci?.opportunity} selectedCustomerId={selectedCustomerId} enabled={detailedData?.bci?.enabled} />
                    <ServiceTableSingleRow isFilterExpanded={isFilterExpanded} heading='crosssell' count={detailedData?.crossSell?.itemsSoldCrossSell} opportunity={detailedData?.crossSell?.opportunity} selectedCustomerId={selectedCustomerId} enabled={detailedData?.crossSell?.enabled} />
                </Box>
            </Col>
            <Col xs={24} sm={24} md={1} className='h-full' >

            </Col>
            <Col xs={24} sm={24} md={12} className='h-full' >

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: "0.8vh" }}>
                    <ServicesTable isFilterExpanded={isFilterExpanded} selectedScatterData={selectedScatterData} data={detailedData?.sku} headerValue='sku' selectedCustomerId={selectedCustomerId} />
                    <ServiceTableSingleRow isFilterExpanded={isFilterExpanded} heading='cts' count={detailedData?.cts?.adherence} opportunity={detailedData?.cts?.opportunity} selectedCustomerId={selectedCustomerId} enabled={detailedData?.cts?.enabled} district={selectedDistrict} />
                </Box>

            </Col>
        </Row>
    </Box>

    )
}

export default CustomerSelectedOpportunities;